import React from "react";
import DataTable from "react-data-table-component";
const customStyles = {
  rows: {
    style: {
      minHeight: "72px", // override the row height
      padding: "0 !important",
      whiteSpace: "normal !important",
    },
  },
  headCells: {
    style: {
      paddingLeft: "0", // override the cell padding for head cells
      paddingRight: "0",
      backgroundColor: "#5e2b97",
      color: "#fff !important",
      padding: "0px !important",
      maxWidth: "12%",
      minWidth: "12%",
    },
  },
  cells: {
    style: {
      paddingLeft: "0", // override the cell padding for data cells
      paddingRight: "0",
      whiteSpace: "normal",
      maxWidth: "12%",
      minWidth: "12%",
      textAlign: "left",
      whiteSpace: "normal !important",
    },
  },
};
export default function DataTableList({ columns, lovedOneData }) {
  function convertArrayOfObjectsToCSV(array) {
    let result;

    const columnDelimiter = ",";
    const lineDelimiter = "\n";
    const keys = Object.keys(lovedOneData[0]);

    result = "";
    result += keys.join(columnDelimiter);
    result += lineDelimiter;

    array.forEach((item) => {
      let ctr = 0;
      keys.forEach((key) => {
        if (ctr > 0) result += columnDelimiter;

        result += item[key];

        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  }
  function downloadCSV(array) {
    const link = document.createElement("a");
    let csv = convertArrayOfObjectsToCSV(array);
    if (csv == null) return;

    const filename = "export.csv";

    if (!csv.match(/^data:text\/csv/i)) {
      csv = `data:text/csv;charset=utf-8,${csv}`;
    }

    link.setAttribute("href", encodeURI(csv));
    link.setAttribute("download", filename);
    link.click();
  }
  const Export = ({ onExport }) => (
    <button
      className="btn btn-primary"
      onClick={(e) => onExport(e.target.value)}
    >
      Export
    </button>
  );
  const actionsMemo = React.useMemo(
    () => <Export onExport={() => downloadCSV(lovedOneData)} />,
    []
  );
  return (
    <DataTable
      className="table table-striped table-bordered"
      columns={columns}
      data={lovedOneData}
      pagination
      // actions={actionsMemo}
      customStyles={customStyles}
    />
  );
}
